angular.module("componentes").directive("textField", [
	"$timeout",
	function ($timeout) {
		"use strict";
		return {
			scope: true,
			controller: "TextFieldCtrl",
			controllerAs: "ctrl",
			replace: true,
			templateUrl: "componentes/angular-material/custom/fields/textField/textField_template.html",
			bindToController: {
				label: "@",
				name: "@",
				isDisabled: "=",
				isRequired: "=",
				type: "@",
				field: "=",
				mask: "@?",
				maxlength: "@?",
				minlength: "@?",
				error: "=?",
				customErrorMessage: "=?",
				changed: "=?",
				decimalPlaces: "=?",
				forceDecimalPlaces: "@?",
				onBlur: "=?",
				customClass: "@",
				initCurrentDate: "@",
				autofocus: "@?",
				showEye: "=?",
				helper: "=",
				ignoreDateLimits: "=",
				onFocus: "=?",
				minDate: "=?",
				maxDate: "=?",
				typingInterval: "@?",
				regex: "@?"
			},
			require: "^?form",
			link: function (scope, element, attrs, form) {
				scope.ctrl.form = form;
			}
		};
	}
]);
